import { useEffect } from "react";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";
import { uggGAEvent } from "@ugitgud/legos/components/util/UggGAEventProvider";

export const PERSONALIZED_STATS_BANNER_CTA = "personalized-stats-banner-cta";

interface PersonalizedStatsBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function PersonalizedStatsBanner(props: PersonalizedStatsBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;
  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  useEffect(() => {
    uggGAEvent("plus-banner-cta-view", utmSource || "unknown");
  }, []);

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div className={classNames("w-full h-[48px] bg-[#0C3050] flex items-center relative overflow-hidden", className)}>
      <img
        src="https://static.bigbrain.gg/assets/ugg/cta/personal-stats-banner.png"
        alt="site-wide top banner"
        className="absolute max-w-none top-0 h-[48px] shrink-0 right-[-394px] xs:right-[-250px] lg:right-[-150px] xl:right-0"
      />

      <div
        className={classNames(
          "absolute inset-0 z-10 flex items-center justify-start md:justify-center pl-3 md:pl-6 pr-2 md:pr-4 text-white",
          { "pr-8": onClose },
        )}
      >
        <img
          src="https://static.bigbrain.gg/assets/ugg/images/player-personal-stats.png"
          alt="personal stats example"
          className="hidden sm:block w-[289.96px] h-[36px] shrink-0 self-center translate-y-[2px] -ml-1 mr-3 md:mr-8"
        />

        <div className="flex flex-col justify-center shrink-0">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-[32px] h-[15px] rounded text-[9px] font-bold leading-none border border-accent-yellow-400 bg-accent-brown-400 text-accent-yellow-400 shrink-0">
              PLUS
            </span>
            <span className="font-['Barlow_Condensed'] font-bold text-[18px] uppercase leading-none tracking-wide whitespace-nowrap">
              Personal Stats &amp; Counters
            </span>
          </div>
          <span className="text-[12px] text-white leading-none mt-[3px]">Exclusive U.GG PLUS features have arrived</span>
        </div>

        <div
          className="flex items-center justify-center gap-1.5 w-[107px] h-[30px] shrink-0 bg-accent-brown-400 border border-accent-yellow-400 rounded cursor-pointer hover:bg-purple-100 transition-colors ml-3"
          onClick={onUrlClick}
        >
          <span className="font-['Barlow_Condensed'] font-semibold text-white text-[13px] whitespace-nowrap">DISCOVER</span>
          <span className="inline-flex items-center justify-center w-[32px] h-[15px] rounded text-[9px] font-bold leading-none border border-accent-yellow-400 bg-accent-brown-400 text-accent-yellow-400">
            PLUS
          </span>
        </div>
      </div>

      {onClose && (
        <div
          className="absolute z-20 top-1/2 right-[12px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)]" />
        </div>
      )}
    </div>
  );
}
